"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var Card_1 = __importDefault(require("@material-ui/core/Card"));
var CardActionArea_1 = __importDefault(require("@material-ui/core/CardActionArea"));
var CardContent_1 = __importDefault(require("@material-ui/core/CardContent"));
var CardMedia_1 = __importDefault(require("@material-ui/core/CardMedia"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var react_intl_1 = require("react-intl");
var core_1 = require("@material-ui/core");
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            minHeight: 300,
            maxWidth: 300,
            width: '80%',
            minWidth: 250,
            marginLeft: '50%',
            transform: 'translate(-50%)'
        },
        media: {
            height: 240,
        },
        title: {
            margin: 0,
            padding: theme.spacing(1),
            textAlign: "center"
        },
        body: {
            height: 60,
            margin: 0,
            textAlign: "center"
        }
    });
});
var ProductType = function (props) {
    var classes = useStyles();
    var handleClick = function () {
        props.changeType(props.textId);
    };
    return (react_1.default.createElement(Card_1.default, { className: classes.root, onClick: handleClick },
        react_1.default.createElement(CardActionArea_1.default, null,
            react_1.default.createElement(CardMedia_1.default, { className: classes.media, image: props.image, title: props.textId }),
            react_1.default.createElement(core_1.Divider, { variant: "middle" }),
            react_1.default.createElement(CardContent_1.default, { className: classes.body },
                react_1.default.createElement(Typography_1.default, { className: classes.title },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: props.textId }))))));
};
exports.default = ProductType;
